export const DISPOSITION_CALL_DIRECTION_OPTIONS = [
  { value: 'inbound', label: 'Inbound' },
  { value: 'outbound', label: 'Outbound' },
  { value: 'both', label: 'Both' },
] as const;

export type DispositionCallDirection =
  (typeof DISPOSITION_CALL_DIRECTION_OPTIONS)[number]['value'];

export function isValidDispositionCallDirection(
  value: unknown,
): value is DispositionCallDirection {
  return DISPOSITION_CALL_DIRECTION_OPTIONS.some((o) => o.value === value);
}

export function formatDispositionCallDirectionLabel(value: unknown) {
  const key = String(value || '').toLowerCase();
  const match = DISPOSITION_CALL_DIRECTION_OPTIONS.find((o) => o.value === key);
  return match?.label || (value ? String(value) : '—');
}

/** True when a saved form can be used for a live inbound/outbound call. */
export function formMatchesCallDirection(formDirection: unknown, callDirection: unknown) {
  const form = String(formDirection || '').toLowerCase();
  const call = String(callDirection || '').toLowerCase();
  if (!call) return true;
  if (form === call) return true;
  if (form === 'both' && (call === 'inbound' || call === 'outbound')) return true;
  return false;
}

/** Wrap-up system defaults are only stored per inbound/outbound. */
export function wrapUpTimingDirection(formDirection: unknown) {
  return String(formDirection || '').toLowerCase() === 'outbound' ? 'outbound' : 'inbound';
}
